const getEnv = (env?: string) => {
  if (env?.match(/dev/)) {
    return "dev";
  } else if (env?.match(/staging/)) {
    return "staging";
  }
  return "prod";
};
export default getEnv;
export { getEnv };
